import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-company.tsx
/**
* icon.24.company
*
* Keywords: devices, phone, tablet, mobile, connected, sync, multiple, pairing
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNyA2aDV2MTFoLTF2LTJhMSAxIDAgMCAwLTEtMUg5YTEgMSAwIDAgMC0xIDF2Mkg3em0yIDExaDF2LTJIOXptMCAxSDdhMSAxIDAgMCAxLTEtMVY2YTEgMSAwIDAgMSAxLTFoNWExIDEgMCAwIDEgMSAxdjExYTEgMSAwIDAgMS0xIDF6bTYuNS0xMGEuNS41IDAgMCAxIC41LjVWMTBoMmExIDEgMCAwIDEgMSAxdjZhMSAxIDAgMCAxLTEgMWgtMy41YS41LjUgMCAwIDEgMC0xSDE4di02aC0zLjVhLjUuNSAwIDAgMSAwLTFoLjVWOC41YS41LjUgMCAwIDEgLjUtLjUiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-9621
*/
const Icon24Company = memo(function Icon24Company(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M7 6h5v11h-1v-2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H7zm2 11h1v-2H9zm0 1H7a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1zm6.5-10a.5.5 0 0 1 .5.5V10h2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-3.5a.5.5 0 0 1 0-1H18v-6h-3.5a.5.5 0 0 1 0-1h.5V8.5a.5.5 0 0 1 .5-.5",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Company };

//# sourceMappingURL=icon-24-company.js.map